var $8dbae7e3487e6fc7$exports = {};
$8dbae7e3487e6fc7$exports = {
    "pending": `pendente`
};


export {$8dbae7e3487e6fc7$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
